import { Link } from 'react-router-dom';
import { HeartIcon, HopeLogo, LittleHeroesLogo } from './Assets';
import BtnComp from './Buttons/BtnComp';
import '../styles/Header.css';

function Header() {
  return (
    <div className="header">
      <div className="header_btn">
        <a 
          href="https://www.paypal.com/donate/?hosted_button_id=J7NBS6WZ67U52" target="_blank" rel="noreferrer noopener" className="donate-link"
        >
          <BtnComp
            btnIcon={HeartIcon}
            btnText="Donate" 
            btnType="primary-btn"
            btnLength="short-btn"
          />
        </a>
      </div>
      <div className="logos">
        <Link to="/" className="logo-container">
          <img src={HopeLogo} alt="HOPE" className="img-size" />
        </Link>
        <Link to="/little-heroes-big-missions" className="logo-container">
          <img src={LittleHeroesLogo} alt="Little Heroes" className="img-size" />
        </Link>
      </div>
      <div className="header_btn temp-hidden">
        <BtnComp
          btnIcon=""
          btnText="Accessibility" 
          btnType="secondary-btn"
          btnLength="short-btn"
        />
      </div>
    </div>
  )
}

export default Header